import type { TradeInfo } from '@carvana/merch-contracts';
import type { PaymentTerm } from '~/contracts/common';
import type VehiclePaymentTerm from '~/contracts/common/VehiclePaymentTerm';
import FinanceInfoFromApi from './FinanceInfoFromApi';

export const nonSearchableError =
  'Unable to find any of the requested vehicles in ElasticSearch';

export enum PricingError {
  None = 'None',
  NoVehiclePricingInfo = 'No terms found for vehicle',
  NonSearchable = 'Vehicle not in Elastic Search',
  ApiError = 'Error fetching pricing'
}

export type VehiclePricingResponse = {
  errors: string[];
  financeInfo: FinanceInfoFromApi;
  price: Partial<VehiclePaymentTerm>;
  searchRequestId?: string;
  tradeInfo?: TradeInfo;
  vehicleId: number;
};

type PricingResponse = {
  financeInfo: FinanceInfoFromApi;
  tradeInfo?: TradeInfo;
  vehiclePaymentTermsMapping: Record<number, PaymentTerm>;
};

export default PricingResponse;
